class EndpointsAPI {
  // Telas
  static tela = '/tela';
  static telaPaginado = '/tela/listar-paginado';

  // Peris
  static perfil = '/perfil';
  static perfilPaginado = '/perfil/buscar-perfis-paginados';
  static perfilComTelas = '/perfil/perfil-com-telas';

  // Manuais
  static manual = '/manual';
  static manualDownload = '/manual/baixar';

  // Mensagens de críticas
  static mensagemCritica = '/criticas';
  static mensagemCriticaPaginado = '/criticas/paginado';

  // Instrucoes
  static instrucoes = '/instrucao';
  static instrucoesPaginado = '/instrucao/buscar-perfis-paginados';
  static instrucoesUrlTela = '/instrucao/buscar-instrucoes-url-telas';
  static instrucoesComTela = '/instrucao/intrucoes-com-telas';

  // FAQ
  static faq = '/faq';
  static faqPaginado = '/faq/buscar-faqs-paginadas';
  static faqComTelas = '/faq/faq-com-telas';
  static faqUrlTela = '/faq/faq-por-url-tela';

  // Motor
  static motorCobranca = '/processo-cobranca';
  static motorCobrancaCnab = '/processo-cobranca/cnab';
  static motorCobrancaPdf = '/processo-cobranca/pdf';
  static motorPagamentos = '/pagamento/processo';
  static motorPagamentosCnab = '/pagamento/processo/cnab';
  static motorConvenios = '/convenio/processo';
  static motorConveniosCnab = '/convenio/processo/cnab';

  // Dashboard
  static odometro = '/grafico/tempoMediaHomologacao';
  static odometroCobrancaSucesso = '/grafico/tempoMediaHomologacaoCompleto';
  static odometroCobrancaHomologacaoCompleto =
    '/grafico/tempoHomologacaoCompleto';

  static odometroPagamento = 'pagamento/grafico/tempoMediaHomologacaoCompleto';
  static odometroPagamentoSucesso = 'pagamento/grafico/tempoMediaHomologacao';

  static odometroConvenios = '/convenio/grafico/tempoMediaHomologacaoCompleto';
  static odometroConveniosSucesso = '/convenio/grafico/tempoMediaHomologacao';
  static relatorioAnaliticoConvenios = '/convenio/relatorios/analitico';
  static relatorioSinteticoConvenios = '/convenio/relatorios/sintetico';

  static quantidadeHomologacaoPendentesConvenios =
    '/convenio/grafico/quantidadeHomologacaoPendentes';
  static quantidadeHomologacaoFinalizadasConvenios =
    '/convenio/grafico/quantidadeHomologacaoFinalizadas';
  static quantidadeHomologacaoConvenios =
    '/convenio/grafico/quantidadeHomologacao';
  static principaisCriticasConvenios = '/convenio/grafico/principaisCriticas';
  static percentualPendenciaHomologacaoConvenios =
    '/convenio/grafico/percentualPendenciaHomologacao';
  static baixarPorIdProcessoCobranca = '/relatorios/analitico/processo';
  static baixarPorIdProcessoConvenio =
    '/convenio/relatorios/analitico/processo';
  static baixarPorIdProcessoPagamento =
    '/pagamento/relatorios/analitico/processo';
  static baixarManualPorId = '/manual/baixar/';

  // Autenticação
  static autenticado = '/autenticado';
  static usuarioInterno = '/interno/autenticar';
  static usuarioExterno = '/externo/autenticar';
}

export { EndpointsAPI };
